import type { ReactNode, ReactElement } from 'react';

import { useEffect, useMemo } from 'react';
// emotion
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import rtlPlugin from '@mui/stylis-plugin-rtl';
// material
import { useTheme } from '@mui/material/styles';
import { prefixer } from 'stylis';

export interface RtlLayoutProps {
  children?: ReactNode;
  [key: string]: any;
}

// ----------------------------------------------------------------------

export default function RtlLayout({ children }: RtlLayoutProps) {
  const theme = useTheme();

  useEffect(() => {
    document.dir = theme.direction;
  }, [theme.direction]);

  const cache = useMemo(
    () =>
      createCache({
        key: theme.direction === 'rtl' ? 'muirtl' : 'css',
        prepend: true,
        stylisPlugins: theme.direction === 'rtl' ? [prefixer, rtlPlugin] : [],
      }),
    [theme.direction]
  );

  return <CacheProvider value={cache}>{children}</CacheProvider>;
}
